import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CONTACT_PATH } from '../../content/contacts.js';
import './ContactCta.css';

/**
 * "Skal vi ta en prat?" block at the bottom of the front page and the feature pages. Its
 * "Prøv gratis" button leads to the "Ta kontakt" cards on the "Om oss" page, like every other
 * "Prøv gratis" button.
 * @returns {JSX.Element} Contact section
 */
function ContactCta() {
  const { t } = useTranslation();

  return (
    <section className="contact-cta" aria-labelledby="contact-cta-title">
      <div className="contact-cta-card">
        <h2 id="contact-cta-title">{t('contact.title')}</h2>
        <p className="contact-cta-body">{t('contact.body')}</p>
        <Link to={CONTACT_PATH} className="button button-primary button-large">
          {t('contact.button')}
        </Link>
      </div>
    </section>
  );
}

export default ContactCta;
